import type { LanguageCode } from "../state/i18n.tsx";

export const formatNumber = (language: LanguageCode, number: number) =>
  new Intl.NumberFormat(language, {}).format(number);
